module.exports = __webpack_public_path__ + "img/photo_js.b8deee7e.png";